export default __webpack_public_path__ + "static/media/Legal advisory.c6291122.png";